<template>
    <div id="app">
        <header>
            <span class="monospaced">~ $ ./garage</span>
            <span class="monospaced blinking-cursor">_</span>
        </header>
        <main>
        <router-view>
        </router-view>
        </main>
        <footer>
            <span class="monospaced">[Process finished with exit code 0]</span>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'app'
}
</script>

<style>
body {
    margin: 0;
}

.monospaced {
    font-family: "Lucida Console", Monaco, monospace;
}

#app {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #222;
}

main {
    flex:1;
    margin-top: 40px;
}


footer {
    font-size: 0.8em;
    color: #888;
    text-align: center;
    margin: 1.5em 0;
}

header {
    margin: 0;
    height: 56px;
    padding: 0 16px 0 24px;
    background-color: #222;
    color: #ffffff;
}

header span {
    display: inline-block;
    position: relative;
    font-size: 20px;
    line-height: 1;
    font-weight: 400;
    padding-top: 16px;
}

.blinking-cursor {
    font-weight: bold;
    animation-name: blinking;
    animation-iteration-count: infinite;
    animation-timing-function: cubic-bezier(1,0,0,1);
    animation-duration: 1s;
}

@keyframes "blinking" { 
    from { opacity: 1.0; } to { opacity: 0.0; }
}

</style>



// WEBPACK FOOTER //
// App.vue?75dbf400